const guiColors = {
    'motion-primary': '#ff4c4c',
    'motion-primary-transparent': '#ff4c4ce6',
    'motion-tertiary': '#cc3333',

    'looks-secondary': '#ff4c4c',
    'looks-transparent': '#ff4d4d59',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(0, 42%, 51%, 1)',

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(10, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#ff8c8c',
    'mode-toggle':'#d67878',
    'tabswitcher-tabs-equles':'#d65a5a',
    'tabswitcher-tabs-noequles':'#f2caca',
    'tabswitcher-programe-down':'#ffd1d1',
    'tabswitcher-control-first':'#fdf7f7',
    'tabswitcher-control-second':'#fff0f0',
    'tabswitcher-control-third':'#f8e0e0',
    'tabswitcher-serial-second':'#f8e0e0',
    'ic-main-1': '#ff4c4c',//当前项目主颜色
    'ic-main-light-2': '#ff7777',//当前项目主颜色--浅色
    'ic-main-light-very-3': '#ffdddd',//当前项目主颜色--更浅色
    'ic-main-light-pluse-4': '#fff1f1',//当前项目主颜色--极浅色
};

const blockColors = {
    checkboxActiveBackground: '#ff4c4c',
    checkboxActiveBorder: '#cc3333'
};

export {
    guiColors,
    blockColors
};
